<template>
  <div>
    <v-row v-if="loading">
      <v-col>
        <v-progress-circular indeterminate />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card
          flat
          class="px-4 py-3"
          height="100%"
          :key="reRender"
          :class="!isEditCard1 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.profile.name") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2 v-model="card1.name" :isEdit="isEditCard1" />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.address.address") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <LocalisedContentEditable
                      :values="card1.address"
                      @update:values="values => (this.card1.address = values)"
                      :text-area-outlined="false"
                      :editable="isEditCard1"
                      css-class="text-subtitle-1 font-weight-regular textLight--text"
                      :showLanguageTabs="false"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.profile.companyProfile.contact") }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.phone"
                      :isEdit="isEditCard1"
                      :validateRules="'numeric|max:10'"
                      ref="phone"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.alternateNo")
                    }}</span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.alternatePhone"
                      :isEdit="isEditCard1"
                      :validateRules="'numeric|max:10'"
                      ref="alternatePhone"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.profile.companyProfile.fax") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2 v-model="card1.fax" :isEdit="isEditCard1" />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.email") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.email"
                      :isEdit="isEditCard1"
                      :validateRules="'required|email'"
                      ref="email"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{ $t("user.profile.companyProfile.website") }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.website"
                      :isEdit="isEditCard1"
                      :validateRules="'url'"
                      ref="website"
                    />
                  </v-col>
                </v-row>
                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>{{
                      $t("user.profile.companyProfile.currency")
                    }}</span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <v-select
                      :readonly="!isEditCard1"
                      hide-details
                      v-model="card1.currency"
                      :items="supportedCurrencies"
                      item-value="symbol"
                      item-text="symbol"
                      dense
                      filled
                      class="rounded-xl text-body-2 ma-0 hide-underline"
                    />
                  </v-col>
                </v-row>

                <!-- <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span> {{ $t("user.signature") }} </span>
                  </v-col>
                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    :style="!isEditCard1 ? 'pointer-events: none' : ''"
                  >
                    <image-uploader
                      id="training-image"
                      :maxWidth="900"
                      :maxHeight="450"
                      :quality="0.9"
                      :autoRotate="true"
                      outputFormat="blob"
                      :preview="false"
                      :capture="false"
                      accept="image/*"
                      doNotResize="['gif', 'svg']"
                      @input="onFileSelect"
                    >
                      <label for="training-image" slot="upload-label">
              
                        <v-container
                          v-if="signatureImageUrl"
                          fluid
                          class="pa-0"
                          style="position: relative"
                        >
                          <v-img
                            :src="signatureImageUrl"
                            alt="Img"
                            :max-height="signatureImageHeight"
                            cover
                            style="border-radius: 7px"
                            contain
                          />
                          <div
                            style="position: absolute; bottom: 5px; right: 5px"
                            v-if="isEditCard1"
                          >
                            <v-btn
                              small
                              color="error"
                              min-width="80"
                              class="rounded-1"
                              @click.prevent="cancelMediaSelection"
                            >
                              {{ $t("course.courseDetails.cancel") }}
                            </v-btn>
                          </div>
                        </v-container>

                        <v-container
                          v-else-if="card1.signature"
                          fluid
                          class="pa-0"
                          style="position: relative"
                        >
                          <v-img
                            :src="getImage(card1.signature)"
                            alt="Img"
                            :max-height="signatureImageHeight"
                            cover
                            style="border-radius: 7px"
                            contain
                          />
                        </v-container>

                        <v-container
                          v-else
                          fluid
                          class="fill-height justify-center pa-0"
                          style="
                            border-style: dashed;
                            border-radius: 7px;
                            border-width: 3px;
                            opacity: 0.5;
                          "
                          :style="`height: ${signatureImageHeight}px`"
                        >
                          <div
                            class="textLight--text text-capitalize hand-cursor"
                            style="opacity: 0.5"
                          >
                            <v-icon class="d-flex" size="40">mdi-plus</v-icon>
                            <div>
                              {{ $t("organization.uploadImage") }}
                            </div>
                          </div>
                        </v-container>
                      </label>
                    </image-uploader>
                  </v-col>
                </v-row> -->
              </v-col>
            </v-row>
          </div>
          <float-btn
            v-if="!loading"
            :isEdit="isEditCard1"
            @save="saveCard1Items"
            @edit="isEditCard1 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData1"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="
            snackbarError = false;
            snackbarErrorMessage = null;
          "
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Editable2 from "../../../core-module/components/ContentEditable2.vue";
import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";
import FloatBtn from "../employee-profile/FloatBtn.vue";

import { createOrUpdateSubscriberProfile } from "../../methods/createOrUpdateSubscriberProfile";
import { saveUser } from "../../helpers/authHelper";

import { mapState } from "vuex";

export default {
  components: {
    Editable2,
    FloatBtn,
    LocalisedContentEditable,
  },
  props: {
    companyData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
      card1: {
        name: "",
        address: "",
        email: "",
        phone: "",
        alternatePhone: "",
        fax: "",
        website: "",
        currency: "",
        // signature: "",
      },
      card1Error: {
        email: null,
        phone: null,
        alternatePhone: null,
        website: null,
      },
      companyProfile: null,
      savingData1: false,
      isEditCard1: false,
      reRender: 0,
      signatureImage: null,
      signatureImageUrl: null,
    };
  },
  computed: {
    ...mapState({
      supportedCurrencies: "supportedCurrencies",
    }),
    signatureImageHeight() {
      return this.$vuetify.breakpoint.xlOnly
        ? 400
        : this.$vuetify.breakpoint.lgAndUp
        ? 150
        : 250;
    },
  },
  created() {
    // console.log(this.supportedCurrencies);
  },

  watch: {
    companyData: {
      immediate: true,
      handler() {
        this.companyProfile = this.companyData ? this.companyData : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    onFileSelect(output) {
      var reader = new FileReader();
      reader.readAsDataURL(output);
      var self = this;

      reader.onloadend = function () {
        var base64data = reader.result;
        // self.categoryInput.url = base64data;
        self.signatureImageUrl = base64data;
      };
      this.signatureImage = output;
    },
    cancelMediaSelection() {
      this.signatureImage = null;
      this.signatureImageUrl = null;
      const el = document.getElementById("training-image");
      if (el) el.value = "";
    },
    resetFormData() {
      this.card1.name = this.companyProfile?.user?.firstName;
      this.card1.email = this.companyProfile?.user?.email;
      this.card1.phone = this.companyProfile?.user?.phone?.number;
      this.card1.address = this.companyProfile?.basicInfo?.address;
      this.card1.alternatePhone =
        this.companyProfile?.basicInfo?.alternatePhone;
      this.card1.fax = this.companyProfile?.basicInfo?.fax;
      this.card1.website = this.companyProfile?.basicInfo?.website;
      this.card1.currency = this.companyProfile?.basicInfo?.currency;
      // this.card1.signature = this.companyProfile?.signature;

      this.reRender++;
    },
    resetCard1Error() {
      this.card1Error = {
        email: null,
        phone: null,
        alternatePhone: null,
        website: null,
      };
    },
    async saveCard1Items() {
      this.resetCard1Error();
      this.snackbarErrorMessage = null;
      this.card1Error.email = (await this.$refs.email.checkIsValid())
        ? null
        : true;
      this.card1Error.phone = (await this.$refs.phone.checkIsValid())
        ? null
        : true;
      this.card1Error.alternatePhone =
        (await this.$refs.alternatePhone.checkIsValid()) ? null : true;
      this.card1Error.website = (await this.$refs.website.checkIsValid())
        ? null
        : true;
      if (Object.values(this.card1Error).some(x => x != null)) {
        return;
      }
      this.savingData1 = true;
      this.isEditCard1 = false;
      let saveData = {
        user: {
          firstName: this.card1.name ? this.card1.name : null,
          email: this.card1.email ? this.card1.email : null,
          phone: {
            countryCode: "+965",
            number: this.card1.phone ? this.card1.phone : "",
          },
        },
        basicInfo: {
          address: this.card1.address
            ? this.filterEmptyLocalisedValues(this.card1.address)
            : null,
          alternatePhone: this.card1.alternatePhone
            ? this.card1.alternatePhone
            : null,
          fax: this.card1.fax ? this.card1.fax : null,
          website: this.card1.website ? this.card1.website : null,
          currency: this.card1.currency ? this.card1.currency : null,
        },
      };

      // if (this.signatureImage instanceof Blob) {
      //   saveData.signature = this.signatureImage;
      // }

      this.createOrUpdateProfile(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
          this.resetFormData();
        }

        if (response?.data?.user) saveUser(response.data.user);

        this.savingData1 = false;
      });
    },

    createOrUpdateProfile(data) {
      return createOrUpdateSubscriberProfile(data);
    },
  },
};
</script>

<style scoped>
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
